module.exports = __webpack_public_path__ + "img/icon_rail.967fb9cd.png";